/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ServiceDriverDTO } from '../../entities/service/DriverDTO'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { serviceTargetDTOSchema } from './targetDTOSchema'
import { z } from 'zod'

export const serviceDriverDTOSchema = z.object({
  drivee_id: z.number().int(),
  last_activity_date: z.string().optional(),
  phone: z.string(),
  recruiter_name: z.string(),
  registration_date: z.string(),
  target: z.lazy(() => serviceTargetDTOSchema).optional(),
}) as unknown as ToZod<ServiceDriverDTO>